var WebFont = require('webfontloader');

WebFont.load({
  // Fonts to load, make sure this matches the styles we actually use
  google: {
    families: [
        'Open Sans:300,400,400i,700',
        'Raleway:400',
    ]
  },
  loading: function() {},
  active: function() {},
  inactive: function() {},
  fontloading: function(familyName, fvd) {},
  fontactive: function(familyName, fvd) {},
  fontinactive: function(familyName, fvd) {},
  timeout: 2000 // Set the timeout to two seconds/
});
